import api from "../config/api";

// Kullanıcı girişi
export const login = async ({ email, password }) => {
  try {
    const response = await api.post("/auth/login", { email, password });
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Kullanıcı kaydı
export const register = async ({
  email,
  password,
  confirm_password,
  first_name,
  last_name,
}) => {
  try {
    const response = await api.post("/auth/register", {
      email,
      password,
      confirm_password,
      first_name,
      last_name,
    });
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Kullanıcı çıkışı
export const logout = async () => {
  try {
    const response = await api.post("/auth/logout");
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Şifre sıfırlama isteği
export const requestPasswordReset = async (email) => {
  try {
    const response = await api.post("/auth/request-reset", { email });
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Şifre sıfırlama
export const resetPassword = async ({ token, newPassword }) => {
  try {
    const response = await api.post("/auth/reset-password", {
      token,
      newPassword,
    });
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Kullanıcı bilgilerini id ile getirmek için
export const getUserById = async (id) => {
  try {
    const response = await api.get(`/auth/users/${id}`);
    console.log("API Response (getUserById):", response);
    return response;
  } catch (error) {
    console.error("API Error (getUserById):", error.response || error);
    throw error;
  }
};

// Kullanıcı silme
export const deleteUser = async (id) => {
  try {
    const response = await api.delete(`/users/${id}`);
    console.log("API Response (deleteUser):", response);
    return response;
  } catch (error) {
    console.error("API Error (deleteUser):", error.response || error);
    throw error;
  }
};
